import React, { useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import Side from '../Side';
import Stages from '../Stages';
import Questions from '../Questions';
import { getLinkWithPdfData } from '../../utils';
import { answersTransformer } from '../../transformer';

import styles from './styles.module.scss';

const Section = ({ stage, setStage, recommendation, stages, setStages }) => {
  const [step, setStep] = useState(stage.steps[0]);
  const isDesktop = useMediaQuery('(min-width: 1325px)');

  const setStepAnswers = (questions, callback) => {
    let curStep = stage.curStep;
    const curStages = [...stages];

    curStages.forEach((stageItem) => {
      if (stageItem.key !== stage.key) {
        return stageItem;
      }

      if (stage.curStep <= stageItem.steps.length) {
        curStep = stage.curStep + 1;
        stageItem.curStep = curStep;
      }

      if (stage.curStep > stageItem.steps.length) {
        stageItem.completed = true;
      }

      stageItem.steps.map((stepItem) => {
        if (stepItem.key === step.key) {
          stepItem.questions = questions;
          stepItem.completed = true;
        }

        return stepItem;
      });

      return stageItem;
    });

    setStages(curStages);

    if (stage.curStep > stage.steps.length) {
      let newStage = null;
      const link = getLinkWithPdfData(answersTransformer(stages, recommendation));

      if ('both' === recommendation && 'solutions' === stage.key) {
        newStage = stages[1];
        newStage.curStep = 1;
        newStage.link = link

        // Go to next stage
        setStage(newStage);
      } else {
        newStage = stages[2];
        newStage.link = link

        // Go to results stage
        setStage(newStage);
      }
    } else {
      setStep(stage.steps[curStep - 1]);
      callback(stage.steps[curStep - 1]);
    }
  };

  const startOver = () => {
    window.location.replace(window.location.pathname);
  }

  const back = (callback) => {
    let curStep = stage.curStep;
    const curStages = [...stages];

    curStages.map((stageItem) => {
      if (stageItem.key !== stage.key) {
        return stageItem;
      }

      if (stage.curStep <= stageItem.steps.length) {
        curStep = stage.curStep - 1;
        stageItem.curStep = curStep;
      }

      stageItem.steps.map((stepItem) => {
        if (stepItem.key === step.key) {
          stepItem.completed = false;
        }

        return stepItem;
      });

      return stageItem;
    });

    setStages(curStages);

    setStep(stage.steps[curStep - 1]);
    callback(stage.steps[curStep - 1]);
  }

  const backStage = (callback) => {
    let curStep = stage.curStep;
    const curStages = [...stages];

    curStages.map((stageItem) => {
      if (stageItem.key !== stage.key) {
        return stageItem;
      }

      if (stage.curStep <= stageItem.steps.length) {
        curStep = stage.curStep - 1;
        stageItem.curStep = curStep;
      }

      stageItem.steps.map((stepItem) => {
        if (stepItem.key === step.key) {
          stepItem.completed = false;
        }

        return stepItem;
      });

      return stageItem;
    });

    setStages(curStages);

    stages[0].curStep = 1;

    setStage(stages[0]);
    setStep(stages[0].steps[0]);
    callback(stages[0].steps[0]);
  }

  return <div className={styles.container}>
    <div className={styles.left_side + ' ' + ('devices' === stage.key ? styles.devices : styles.solutions)}>
      <Side
        stage={stage}
        step={step}
        startOver={startOver}
      />
    </div>
    {isDesktop ? '' : <div className={styles.stages_container + ' ' + ('both' === recommendation ? styles.stages_container_full : '')}>
      <div className={styles.stages + ' ' + ('results' !== stage.key ? styles.stages_animate : '')}>
        <Stages
          stages={stages}
          setStage={setStage}
          currentStage={stage}
          currentStep={step}
          recommendation={recommendation}
        />
      </div>
    </div>}
    <div className={styles.section_content}>
      <div className={styles.content + ' ' + ('results' !== stage.key ? styles.content_animate : '')}>
        <Questions
          stages={stages}
          stage={stage}
          step={step}
          back={back}
          backStage={backStage}
          setStepAnswers={setStepAnswers}
          setStage={setStage}
          recommendation={recommendation}
        />
      </div>
    </div>
    {isDesktop ? <div className={styles.stages_container}>
      <div className={styles.stages + ' ' + ('results' !== stage.key ? styles.stages_animate : '')}>
        <Stages
          stages={stages}
          setStage={setStage}
          currentStage={stage}
          currentStep={step}
          recommendation={recommendation}
        />
      </div>
    </div> : ''}
  </div>;
}

export default Section;
